import React from 'react';
import { Link } from 'react-router-dom';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import HoverTableRow from '../../commonComponents/util/HoverTableRow';
import ValidatedInput from '../../commonComponents/util/ValidatedInput';
import CurrencyFormatInput from '../../commonComponents/util/CurrencyFormatInput';
import Select from '../../commonComponents/util/Select';
import FadeOutErrorMessage from '../../commonComponents/util/FadeOutErrorMessage';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import { formatCurrency, stripCurrencyFormat } from '../../../lib/utils';
import { ApplicationStatuses } from '../../../lib/systemVariables';

const initialState = {
    editMode: false,
    update: {},
    updateAttempted: false,
    updateError: false
};

export default class CampaignDetailsIndividualsTableRow extends NavigationComponent {
    constructor(props) {
        super(props);

        this.state = initialState;

        this.onChange = this.onChange.bind(this);
    }

    onChange(name, value) {
        let update = { ...this.state.update };
        if (value.toString() === (this.props.recipient[name]).toString()) {
            delete update[name];
        } else {
            update[name] = value;
        }
        this.setState({ update });
    }

    async updateIndividual() {
        this.setState({ updateAttempted: true, updateError: false });

        const { update } = this.state;
        const { campaignIndivCategories, funds, maxAmount, recipient, updateError } = this.props;

        if (!Object.keys(update).length //no update
            || (update.hasOwnProperty('fundId') ? !update.fundId : !recipient.fundId) //no fund
            || ((update.amount || recipient.amount) > maxAmount)) //exceeds limit
            return;

        //set updates name fields for display purposes
        if (update.fundId)
            update.fundName = funds[funds.map(f => f.key.toString()).indexOf(update.fundId.toString())].value;
        if (update.individualCategoryId)
            update.individualCategoryName = campaignIndivCategories[campaignIndivCategories.map(c => c.key.toString()).indexOf(update.individualCategoryId.toString())].value;

        await this.props.update(recipient.recipientId, recipient.applicationId, update);

        if (updateError) {
            this.setState({ updateError: true });
        } else {
            this.cancelUpdate();
        }
    }

    cancelUpdate() {
        this.setState(initialState);
    }

    render() {
        const { applicationId, recipientId, name, amount, fundName, fundId, individualCategoryName, individualCategoryId, status } = this.props.recipient;
        const canApprove = status === ApplicationStatuses.New && amount > 0;

        return (
            <HoverTableRow onClick={this.pushRouteWithProps.bind(this,
                `/recipient-accounts/${recipientId}?applicationId=${applicationId}`, {
                    prevPage: `${this.props.campaignName} Campaign`,
                    campaignId: this.props.campaignId,
                    applicationId
                })}>
                <td data-label="Name">
                    {this.props.canUpdate && <div className={`custom-check-container name-check-container ${!canApprove ? "disabled" : ""}`}>
                        <input type="checkbox" id={`name-${applicationId}`} className="custom-check input"
                            checked={this.props.selected} onChange={() => this.props.toggleSelect(this.props.recipient)} disabled={!canApprove} />
                        <label htmlFor={`name-${applicationId}`} className="secondary-text input" />
                    </div>}
                    <Link
                        className="bold-text"
                        to={`/recipient-accounts/${recipientId}?applicationId=${applicationId}`}>
                        {name}
                    </Link>
                </td>
                <td data-label="Amount">
                    {(this.state.editMode && this.props.canUpdateAmount)
                        ? <div className="dollar-input-container">
                            <div className="dollar-input">
                                <ValidatedInput input={<CurrencyFormatInput className="input" isIsraeli={this.props.isIsraeli} />}
                                    name="amount" value={this.state.update.hasOwnProperty("amount") ? this.state.update.amount : (amount || '')}
                                    onChange={this.onChange.bind(this)} onKeyDown={e => { if (e.key === 'Enter' && Object.keys(this.state.update).length) this.updateIndividual() }}
                                    validated={true} showValidationError={this.state.updateAttempted}
                                    validate={val => !val || stripCurrencyFormat(val) <= this.props.maxAmount}
                                    errorMessage={`Amount cannot exceed ${formatCurrency(this.props.maxAmount, this.props.isIsraeli)}.`} />
                            </div>
                        </div>
                        : <p>{formatCurrency(amount, this.props.isIsraeli)}</p>
                    }
                </td>
                <td data-label="Fund">
                    {this.state.editMode
                        ? <ValidatedInput input={<Select className="input" options={this.props.funds} />}
                            name="fundId" value={this.state.update.hasOwnProperty("fundId") ? this.state.update.fundId : fundId} onChange={this.onChange.bind(this)}
                            required={true} showRequiredError={this.state.updateAttempted} />
                        : <p>{fundName}</p>
                    }
                </td>
                <td data-label="Category">
                    {this.state.editMode
                        ? <ValidatedInput input={<Select className="input" clearable={true} options={this.props.campaignIndivCategories} />}
                            name="individualCategoryId" value={this.state.update.hasOwnProperty("individualCategoryId") ? this.state.update.individualCategoryId : individualCategoryId}
                            onChange={this.onChange.bind(this)}
                            required={false} showRequiredError={this.state.updateAttempted} />
                        : <p>{individualCategoryName}</p>
                    }
                </td>
                {this.props.canUpdateIndividual && <td data-label="Edit">
                    {status === ApplicationStatuses.New && (!this.state.editMode
                        ? <i className="icon-pencil primary-hover input" onClick={() => this.setState({ editMode: true })}></i>
                        : (this.props.updating
                            ? <LoadingSpinner height="12" />
                            : <div>
                                <i className={`material-icons primary-hover input ${!Object.keys(this.state.update).length ? "disabled" : ""}`}
                                    onClick={this.updateIndividual.bind(this)} style={{ fontSize: "15px" }}>check</i>
                                <i className="material-icons primary-hover input" onClick={this.cancelUpdate.bind(this)} style={{ fontSize: "15px", marginLeft: "8px" }}>close</i>
                            </div>)
                    )}
                    <FadeOutErrorMessage show={this.state.updateError} timeOut={5000} message={this.props.updateErrorMessage} />
                </td>}
                {this.props.canUpdate && <td data-label="Remove">
                    <i className="icon-trash trash-hover input" onClick={this.props.remove.bind(this, this.props.recipient)}></i>
                </td>}
            </HoverTableRow>
        );
    };
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignDetails/CampaignDetailsIndividualsTableRow.jsx